var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 66.6667C25 43.1 25 31.3084 32.325 23.9917C39.6417 16.6667 51.4333 16.6667 75 16.6667H125C148.567 16.6667 160.358 16.6667 167.675 23.9917C175 31.3084 175 43.1 175 66.6667V133.333C175 156.9 175 168.692 167.675 176.008C160.358 183.333 148.567 183.333 125 183.333H75C51.4333 183.333 39.6417 183.333 32.325 176.008C25 168.692 25 156.9 25 133.333V66.6667Z",
    stroke: "white",
    strokeWidth: 12.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6666 20.8334V183.333M16.6666 100H33.3333M16.6666 133.333H33.3333M16.6666 66.6667H33.3333M95.8333 54.1667H137.5M95.8333 83.3334H137.5",
    stroke: "white",
    strokeWidth: 12.5,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotebook);
export default __webpack_public_path__ + "static/media/notebook.d31659aca74819db40d93e12c73fab8a.svg";
export { ForwardRef as ReactComponent };